import { PreFooterBanner } from '../PreFooterBanner';

interface ISmbContentProps {
  startBlock: React.ReactNode;
  steps: React.ReactNode;
  faq?: React.ReactNode;
  socials?: React.ReactNode;
}

export const SmbContent: React.FC<ISmbContentProps> = ({ startBlock, steps, faq, socials }) => {
  return (
    <div>
      {startBlock}
      {steps}
      {faq}
      <PreFooterBanner />
      {socials}
    </div>
  );
};
